<template>
	<button
		data-section="widget"
		ref="buttonBooking"
		class="btn-booking-cms bookNow"
		type="button"
		:class="this.attributes['use-class'] ? 'btn ' + this.extra_engine_class : 'make-hover ' + this.extra_engine_class"
		@click.prevent="makeRequestBooking"
		:style="getStylesButton"
		:data-custom_click_track_value="this.extra_engine_data"
	>
		{{ label }}
		<sup class="hidden">(opens in new window)</sup>
	</button>
</template>

<script>
export default {
	// 1-5
	name: 'BookingSelect',
	props: {
		attributes: Object,
		label: String,
		template: String,
		booking_engine_site_setup: String,
	},
	computed: {
		getStylesButton() {
			const { border, padding, fontSize, ...rest } = this.attributes;

			let fontSizeCalc = fontSize;
			let paddingCalc = padding;

			if (this.template === 'fixed' && window.screen.width < 900) {
				fontSizeCalc = `${parseFloat(fontSize) * 0.8}rem`;
				let paddings = padding.split(' ');
				paddingCalc = `${paddings[0]} ${parseFloat(paddings[1]) * 0.8}px ${paddings[2]} ${parseFloat(paddings[3]) * 0.8}px`;
			}

			if (this.attributes['use-class']) {
				return {
					border: 'none',
				};
			} else {
				return {
					...rest,
					borderTop: border.top,
					borderBottom: border.bottom,
					borderLeft: border.left,
					borderRight: border.right,
					padding: paddingCalc,
					fontSize: fontSizeCalc,
					'--btn-background-color': this.attributes.backgroundColor,
					'--btn-color': this.attributes.color,
					// width: '100%'
				};
			}
		},
	},
	methods: {
		makeRequestBooking() {
			this.$parent.$emit('request-booking');
		},
	},
	data() {
		return {
			extra_engine_data: '',
			extra_engine_class: '',
		};
	},
	mounted() {
		if (this.booking_engine_site_setup == 'Marriott') {
			this.extra_engine_data = 'NavBar|Hotel Res Click|external|event451';
			this.extra_engine_class = 'custom_click_track';
		}
	},
};
</script>

<style lang="scss">
.btn-booking-cms {
	cursor: pointer;
	margin: 10px 1% 0 1%;
	&.make-hover {
		transition: all 0.4s ease-in-out;
		&:hover {
			background-color: var(--btn-color) !important;
			color: var(--btn-background-color) !important;
			border-color: var(--btn-color) !important;
		}
	}
}
</style>
